module.exports = __webpack_public_path__ + "img/new_banner.596b5293.png";